import { render } from "./ViewAnalyticsPractice.vue?vue&type=template&id=7d97e797&scoped=true"
import script from "./ViewAnalyticsPractice.vue?vue&type=script&lang=js"
export * from "./ViewAnalyticsPractice.vue?vue&type=script&lang=js"

import "@/css/views/view-analytics-practice.css?vue&type=style&index=0&id=7d97e797&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d97e797"]])

export default __exports__